import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationType } from '../constants/notifications';
import { NotificationComponent } from '@app/shared/components/notification/notification.component';
import { NotificationData } from '@app/shared/models/notification-data.model';

@Injectable()
export class NotificationsService {
    constructor(private snackBar: MatSnackBar) {}

    showNotification(type: NotificationType, message: string, duration = 2000): void {
        this.snackBar.openFromComponent<NotificationData>(NotificationComponent, {
            data: {
                type,
                message,
            },
            duration,
            horizontalPosition: 'right',
            verticalPosition: 'top',
        });
    }
}
